(() => {
  const SLIDE_MS = 5000;

  document.querySelectorAll('[data-rechilero-hero-carousel]').forEach((hero) => {
    const images = Array.from(hero.querySelectorAll('.rechilero-hero__bg'));
    const dots = Array.from(hero.querySelectorAll('[data-slide-dot]'));
    if (images.length < 2) return;

    let current = 0;
    let timer = null;

    function goTo(index) {
      images[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      images[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo((current + 1) % images.length);
    }

    function start() {
      stop();
      timer = setInterval(next, SLIDE_MS);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        start();
      });
    });

    // Pausa mientras el mouse esta encima (evita que cambie de imagen
    // mientras alguien esta leyendo/mirando una en particular).
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    start();
  });
})();
